import { render, staticRenderFns } from "./o-sms-modal-ready.vue?vue&type=template&id=124a67b0&"
import script from "./o-sms-modal-ready.vue?vue&type=script&lang=js&"
export * from "./o-sms-modal-ready.vue?vue&type=script&lang=js&"
import style0 from "./o-sms-modal-ready.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports